var Mustache = require('mustache');
import Swiper from "swiper"
import swiperA11y from "./utils/swiperA11y"
import breakpointChecker from "./utils/breakpointChecker"
import config from './utils/config'

(function($){
	if ($('.fund--etfExpertise').length > 0) {
		window.Sharer.init({
			callbackAPI: `etfExpertiseCard__slider`
		})
		let swiper = {}
		const enableSwiper = function(id) {
			if($(`.etfExpertiseCard__slider__${id} .etfExpertiseCard__slide`).length > 3){
				$(`.etfExpertiseCard__slider__${id} .swiper-buttons`).show()
			} else {
				$(`.etfExpertiseCard__slider__${id} .swiper-buttons`).hide()
			}
			$(`.etfExpertiseCard__slider__${id}`).removeClass('etfExpertiseCard__slider--static')
			let _swiper = new Swiper(`.etfExpertiseCard__slider__${id}`, {
				autoplay: false,
				loop: false,
				grabCursor: true,
				watchSlidesVisibility: true,
				pagination: {
					el: `.etfExpertiseCard__slider__${id} .swiper-pagination`,
					type: 'bullets',
					clickable: true
				},
				breakpoints: {
					320: {
						autoHeight: true,
						slidesPerView: 1,
						spaceBetween: 10
					},
					// when window width is >= 992px
					992: {
						autoHeight: true,
						slidesPerView: 3,
						spaceBetween: 10
					},
				},
				navigation: {
					nextEl: `.etfExpertise__${id} .swiper-button-next`,
					prevEl: `.etfExpertise__${id} .swiper-button-prev`,
				},
				init: false,
				on: {
					init: function() {
						swiperA11y.toggleAriaHidden(_swiper, false)
					}
				}
			})
		
			_swiper.init()
			
			_swiper.on('transitionStart', function() {
				swiperA11y.toggleAriaHidden(_swiper, false)
			})
			swiper[id] = _swiper
		}

		function destroySwiper(id) {
			if (!!swiper[id]) {
				swiper[id].destroy( true, true )
			}
			if($(`.etfExpertiseCard__slider__${id} .etfExpertiseCard__slide`).length > 3){
				$(`.etfExpertiseCard__slider__${id} .swiper-buttons`).show()
			} else {
				$(`.etfExpertiseCard__slider__${id} .swiper-buttons`).hide()
			}
			$(`.etfExpertiseCard__slider__${id}`).addClass(`etfExpertiseCard__slider--static`)
			$(`.etfExpertiseCard__slider__${id} .etfExpertiseCard__slide`).removeAttr('aria-hidden').find('a, button').removeAttr('tabindex')
			$(`.etfExpertiseCard__slider__${id}`).removeAttr('aria-hidden').find('a, button').removeAttr('tabindex')
		}

		enableSwiper(1)
		enableSwiper(2)
	}

})(hsvmJQuery)